import { Link } from "react-router-dom";
import styles from "./HomeTopDesc.module.css";
import main_desc from "../../img/main_desc_new.png";
import google from "../../img/badge_google_play.png";
import apple from "../../img/badge_app_store.png";
import { path } from "../common/Common";
import { useEffect, useState } from "react";

/**
 * @author sukim91
 * @date 2022-09-27 10:26:55
 * @remark 메인 컴포넌트
 * @props None
 * @returns <div>
 */
export function HomeTopDesc() {
    const redirect = (link: string) => {
        if (typeof window !== "undefined") {
            window.open(link, "_blank");
        }
    };

    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const checkViewport = () => {
            if (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)) {
                setIsMobileView(true);
            } else {
                setIsMobileView(false);
            }
        };

        checkViewport();
        window.addEventListener("resize", checkViewport);
        return () => window.removeEventListener("resize", checkViewport);
    }, []);

    return (
        <div className={styles.background}>
            <div className={styles.top_container}>
                <div className={styles.contents_wrapper}>
                    <div className={styles.desc_container}>
                        <span className={styles.desc_header}>
                            AI로 세상을 읽고,<br />위치 정보를 지능적으로 표현합니다.
                        </span>
                        <br/>
                        <span className={styles.desc}>
                            데이터로 세상을 이해하고, 전자지도 위에 미래를 그립니다.<br />
                            모두의지도(ModooMap)는 당신의 공간을 디지털로 표현합니다.
                        </span>
                        <div className={`${styles.btn_container} ${isMobileView&&styles.hidden}`}>
                            <Link to={path.CREATE_MAP} style={{ textDecoration: "none" }}>
                                <div className={styles.map_making_btn}>
                                    <span className={styles.btn_inner}>지금 바로 만들어보기</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className={styles.contents_wrapper}>
                    <img src={main_desc} className={styles.main_img} />
                    <div className={styles.badge}>
                        <span>모두의지도 앱이 곧 준비됩니다!</span>
                        {/* <img
                            src={apple}
                            className={styles.apple}
                            onClick={(event) => redirect("https://apps.apple.com/us/app/%EB%AA%A8%EB%91%90%EC%9D%98%EC%A7%80%EB%8F%84/id1540724452")}
                        />
                        <img
                            src={google}
                            className={styles.google}
                            onClick={(event) => redirect("https://play.google.com/store/apps/details?id=dev.ksic.moamapm")}
                        /> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeTopDesc;
